/* src/app/modules/ct-status/components/cts-gantry-functional-unit-step-tile/cts-gantry-functional-unit-step-tile.component.scss */
:host {
  display: flex;
  flex: 1 1 auto;
}
.cts-step-tile {
  height: 1.75rem;
  min-width: 3.5rem;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=cts-gantry-functional-unit-step-tile.component.css.map */
